import { investorApi } from '@core/api/httpClient'
import { PORTFOLIO_ENDPOINTS } from './portfolioEndpointPaths'
import { parseInvestmentDetail } from './parsers/investmentDetailParser'
import {
  parsePortfolioGraphRental,
  parsePortfolioGraphValue,
  parsePortfolioHoldingsSummary,
  parsePortfolioOverview,
  parseRentalIncomeSummary,
} from './parsers/portfolioParser'
import type { InvestmentDetail } from '../types/investmentDetailTypes'
import type {
  PortfolioGraphRental,
  PortfolioGraphValue,
  PortfolioHoldingsSummary,
  PortfolioOverview,
  RentalIncomeSummary,
} from '../types/portfolioTypes'

export async function getRentalIncomeSummary(): Promise<RentalIncomeSummary> {
  const { data } = await investorApi.get<unknown>(PORTFOLIO_ENDPOINTS.RENTAL_INCOME_SUMMARY)
  return parseRentalIncomeSummary(data)
}

export async function getPortfolioOverview(): Promise<PortfolioOverview> {
  const { data } = await investorApi.get<unknown>(PORTFOLIO_ENDPOINTS.OVERVIEW)
  return parsePortfolioOverview(data)
}

export async function getPortfolioGraphValue(): Promise<PortfolioGraphValue> {
  const { data } = await investorApi.get<unknown>(`${PORTFOLIO_ENDPOINTS.GRAPH}?type=value`)
  return parsePortfolioGraphValue(data)
}

export async function getPortfolioGraphRental(): Promise<PortfolioGraphRental> {
  const { data } = await investorApi.get<unknown>(`${PORTFOLIO_ENDPOINTS.GRAPH}?type=rental_income`)
  return parsePortfolioGraphRental(data)
}

export async function getPortfolioHoldingsSummary(): Promise<PortfolioHoldingsSummary> {
  const { data } = await investorApi.get<unknown>(PORTFOLIO_ENDPOINTS.HOLDINGS_SUMMARY)
  return parsePortfolioHoldingsSummary(data)
}

export async function getPortfolioHoldings(page = 1, limit = 10): Promise<unknown> {
  const { data } = await investorApi.get<unknown>(
    `${PORTFOLIO_ENDPOINTS.HOLDINGS}?page=${page}&limit=${limit}`,
  )
  return data
}

export async function getInvestmentDetail(propertyId: string): Promise<InvestmentDetail> {
  const url = PORTFOLIO_ENDPOINTS.HOLDING_DETAIL.replace('{propertyId}', propertyId)
  const { data } = await investorApi.get<unknown>(url)
  return parseInvestmentDetail(data)
}
